import React, { Component } from 'react'
import { Icon } from 'antd'
import PoolGetPaid from './PoolGetPaid'
import PoolGetRefund from './PoolGetRefund'
import { getWinner, getThreshold } from '../../contract/Events';
import { getSettled } from '../../contract/PoolWagers';

export default class MyPoolBetStage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            componentToReturn: <Icon type="loading" />
        }
    }

    componentDidMount() {
        let self = this;
        getWinner(this.props.event.bytes32Id).then(winner => {
            getThreshold(this.props.event.bytes32Id).then(thresh => {
                getSettled(this.props.wager.bytes32Id).then(settled => {
                    self.setState({ winner, thresh, settled });
                    self.setState({ componentToReturn: self.renderStage(self.props.status, self.props.wager) });

                })
            })
        })
    }

    renderStage(status, wager) {
        let component = [];

        if (status == "pregame") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for event</div>);

        } else if (status == "cancelled") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">WAGER REFUNDED</div>);
        } else if (status == "over-oracles") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for Oracles</div>);
        } else if (status == "over-unsettled" || status == "settled-won" || status == "settled-lost") {
          // component.push( <PoolGetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />);
            

            // determine if enough oracle votes     
            if (this.state.winner !== 0 && this.state.thresh) {
                if (this.state.settled) {
                    if (this.state.winner == this.props.wager.makerChoice) {
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                            <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                    } else {
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">WAGER REFUNDED</div>);
                    }
                } else {
                    if (this.state.winner == this.props.wager.makerChoice) {
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized</div>);
                        component.push(<div className="my-bets-page-cards-wagers-wager-options">
                            <div className="my-bets-page-cards-wagers-wager-options-cancel">
                                <PoolGetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                            </div>
                        </div>);
                    } else {
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                        component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                    }
                }
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Winner could not be determined</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <PoolGetRefund bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);
            }
        }
        return component;
    }

    render() {
        return (
            <div>
                {this.state.componentToReturn}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyPoolBetStage.js